import { useMemo } from 'react'

import { useCart } from '@/entities/cart'

import { CartPageScript } from '@/shared/integrations/city-ads/scripts/cart-page-script'

export const CartPageInfoScript = () => {
	const { products } = useCart()

	const caItemsData = useMemo(() => Object.fromEntries(products.map(({ ID, QUANTITY }) => [ID, QUANTITY])), [products])

	if (!products?.length) return null

	return <CartPageScript basket_items={caItemsData} />
}
